import React, { useState } from "react";

import { Card, Typography, Pagination, Table, message, Popconfirm } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";

import { useSelector } from "react-redux";
import BulkCoursesAdd from "../../../../components/AdminComponents/Modals/BulkCoursesAdd";
import axiosInstance from "../../../../api/Axios";
import { DeleteTwoTone } from "@ant-design/icons";

const { Title } = Typography;
const Courses = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/bundledetailslist/?bundle_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Course has been Removed.",
      duration: 5,
    });
    props.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Course Remove Failed",
      duration: 5,
    });
  };

  const handleDelete = async (record) => {
    // const payload = {
    //   // id: record?.id,
    //   course_id: Number(id),
    //   organization_id: userInfo?.data?.organization?.id,
    // };
    // console.log(payload);
    try {
      await axiosInstance.delete(
        `/learn/bundlecoursedelete/${record?.bundle_course_id}/${record?.child_course_id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const columns = [
    {
      title: "Course ID",
      dataIndex: "course_id",
      key: "course_id",
      width: 140,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      width: 150,
    },
    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 150,
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Popconfirm
                  title={"Remove course?"}
                  description=" "
                  onConfirm={() => handleDelete(record)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    key="delete"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.6rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Courses Summary
      </Title>
      <CommonTopDetails
        title={`Bundle Courses`}
        titleSuffix={`${itemsLength || 0} course(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkCoursesAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        bundle_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        ShowMessage={props?.data1?.user_count > 0 ? true : false}
        userCount={props?.data1?.user_count}
      />
    </Card>
  );
};

export default Courses;
